import React, {
  useState, useCallback, useEffect,
} from 'react';
import { Modal } from 'anf-core-react';
import QuickviewContent from './QuickviewContent/QuickviewContent';
import BreakpointProvider from '../../components/BreakpointProvider/BreakpointProvider';
import BrowserProvider from '../../components/BrowserProvider/BrowserProvider';
import SwitchTestProvider from '../../components/SwitchTestProvider/SwitchTestProvider';
import StoreQuickviewProvider, { removeStoredQuickview } from '../../components/StoreQuickviewProvider/StoreQuickviewProvider';
import QuickviewRecommendationsMFE from './QuickviewRecommendationsMFE/QuickviewRecommendationsMFE';

export default function Quickview({ store, storeId }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [quickviewData, setQuickviewData] = useState({});

  const handleOpenModal = useCallback(
    (e) => {
      setIsModalOpen(true);
      setQuickviewData({
        ...e.detail,
      });
    },
    [setIsModalOpen],
  );

  const onModalOpenCallback = useCallback(
    () => {
      if (typeof quickviewData.onModalOpen === 'function') {
        quickviewData.onModalOpen();
      }
    },
    [quickviewData],
  );

  const onModalCloseCallback = useCallback(
    () => {
      if (typeof quickviewData.onModalClose === 'function') {
        quickviewData.onModalClose();
      }
    },
    [quickviewData],
  );

  const onModalPrimaryActionSuccessCallback = useCallback(
    () => {
      if (typeof quickviewData.onModalPrimaryActionSuccess === 'function') {
        quickviewData.onModalPrimaryActionSuccess();
      }
    },
    [quickviewData],
  );

  useEffect(() => {
    document.addEventListener('quickview:mfe:openModal', handleOpenModal);
    return () => {
      document.removeEventListener('quickview:mfe:openModal', handleOpenModal);
    };
  }, [handleOpenModal]);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    quickviewData.returnFocus?.focus();
    removeStoredQuickview();
    onModalCloseCallback();
  }, [quickviewData, onModalCloseCallback]);

  return (
    <>
      <QuickviewRecommendationsMFE
        placementIds="item_page.quickView_rr1|item_page.quickView_rr2|item_page.quickView_rr3|item_page.quickView_rr4|item_page.quickView_rr5|item_page.quickView_rr6"
        clientId="quickview-1"
      />
      <QuickviewRecommendationsMFE
        placementIds="add_to_cart_page.rr1|add_to_cart_page.rr2|add_to_cart_page.rr3|add_to_cart_page.rr4|add_to_cart_page.rr5|add_to_cart_page.rr6"
        clientId="addToBag-2"
      />

      <StoreQuickviewProvider
        orderItemId={quickviewData.orderItemId}
        setIsModalOpen={setIsModalOpen}
        setQuickviewData={setQuickviewData}
      >
        <Modal
          id="mfe-quickview-modal"
          isOpen={isModalOpen}
          variant="headerless"
          onClose={handleCloseModal}
          classList="modal-width product-mfe-web-service"
        >
          <SwitchTestProvider>
            <BrowserProvider>
              <BreakpointProvider>
                <div className="scope-1892" data-testid="mfe-quick-view-content">
                  <QuickviewContent
                    collectionId={quickviewData?.collectionId}
                    productId={quickviewData?.productId}
                    sku={quickviewData?.sku}
                    faceout={quickviewData?.faceout}
                    type={quickviewData.type}
                    orderItemId={quickviewData?.orderItemId}
                    store={store}
                    storeId={storeId}
                    handleCloseModal={handleCloseModal}
                    onModalOpenCallback={onModalOpenCallback}
                    onModalPrimaryActionSuccessCallback={onModalPrimaryActionSuccessCallback}
                    pageViewMethod={quickviewData?.pageViewMethod}
                    productViewMethod={quickviewData?.productViewMethod}
                    dataText={quickviewData?.dataText}
                    dataAction={quickviewData?.dataAction}
                  />
                </div>
              </BreakpointProvider>
            </BrowserProvider>
          </SwitchTestProvider>
        </Modal>
      </StoreQuickviewProvider>
    </>
  );
}
